import config from '../../config';

const { REACT_APP_API_HOST_NAME, V2_API_HOST_NAME } = config;

export const API_HOST_NAME = REACT_APP_API_HOST_NAME;

export const V1_API_BASE_URL = `${API_HOST_NAME}/api`;

export const V2_API_BASE_URL = `${V2_API_HOST_NAME}/api/metrics/v2`;

export const SCHOOL_FINDER = 'https://www.peachjar.com/schoolfinder.html';



// WEBPACK FOOTER //
// ./src/shared/constants/urls.js